export default __webpack_public_path__ + "static/media/3.ad8b5f03.svg";